import { useAppSelector } from '@store';
import useCustomMargins from '../hooks/use-custom-margins';
import { CustomMarginsTypes } from '../types';
import CustomMarginsContent from '../../../../components/common/tariff/margins';
import { OrganizationType } from '../../types';

const CustomMargins = ({
  showMoreCurrencies,
  menuOnFocus,
  setShowMoreCurrencies,
  defaultMargin,
  tariffId,
  allMarginsVisible,
  customerId,
  customMargins,
  setAllMarginsVisible,
  setSelectedCurrency,
  selectedCurrency,
  setMenuOnFocus,
  type,
  customMarginsPagination,
  setSeletedMarginId,
  setMarginPanelIsOpen,
  customMarginsErrorsList,
}: CustomMarginsTypes) => {
  const {
    settings,
    currenciesList: currencies,
    currencies: currenciesList,
  } = useAppSelector((state) => state.root);
  const { rateSources } = useAppSelector((state) => state.customerTariffs);
  const { baseInformation } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const { baseInformation: corporateBaseinformation } = useAppSelector(
    (state) => state.corporateCustomers.info.general,
  );

  const tariffInfo =
    type === OrganizationType.INDIVIDUAL
      ? baseInformation
      : corporateBaseinformation;

  const {
    marginsIsLoading,
    onAllMarginsCurrencyFilter,
    formattedMarginsData,
    errorList,
    filters,
    onMarginsFilterChange,
    filtersComponent,
    handleSubmit,
    marginsIsFetching,
    allMarginsErrorsList,
    allMarginFilters,
    onAllMarginsFilterChange,
    allMarginsFitlersComponent,
    allMarginsHandleSubmit,
    setPage,
  } = useCustomMargins({
    rateSources,
    currencies,
    defaultMargin,
    tariffId,
    allMarginsVisible,
    customerId,
    settings,
    customMargins,
    setSelectedCurrency,
    selectedCurrency,
  });

  return (
    <CustomMarginsContent
      allMarginsVisible={allMarginsVisible}
      setAllMarginsVisible={setAllMarginsVisible}
      setSelectedCurrency={setSelectedCurrency}
      currencies={currencies}
      currenciesList={currenciesList}
      selectedCurrency={selectedCurrency}
      showMoreCurrencies={showMoreCurrencies}
      setShowMoreCurrencies={setShowMoreCurrencies}
      setMenuOnFocus={setMenuOnFocus}
      customMargins={customMargins}
      customerId={customerId}
      tariffId={tariffInfo?.tariffId}
      customMarginsPagination={customMarginsPagination}
      menuOnFocus={menuOnFocus}
      rateSources={rateSources}
      setSeletedMarginId={setSeletedMarginId}
      setMarginPanelIsOpen={setMarginPanelIsOpen}
      defaultMargin={defaultMargin}
      marginsIsLoading={marginsIsLoading}
      onAllMarginsCurrencyFilter={onAllMarginsCurrencyFilter}
      formattedMarginsData={formattedMarginsData}
      errorList={errorList}
      filters={filters}
      onMarginsFilterChange={onMarginsFilterChange}
      filtersComponent={filtersComponent}
      handleSubmit={handleSubmit}
      allMarginsErrorsList={allMarginsErrorsList}
      allMarginFilters={allMarginFilters}
      onAllMarginsFilterChange={onAllMarginsFilterChange}
      allMarginsFitlersComponent={allMarginsFitlersComponent}
      allMarginsHandleSubmit={allMarginsHandleSubmit}
      setPage={setPage}
      marginsIsFetching={marginsIsFetching}
      customMarginsErrorsList={customMarginsErrorsList}
    />
  );
};

export default CustomMargins;
